<template>
  <div>
    <v-data-table
      :headers="tableHeaders"
      :items="searchResults"
      class="elevation-1"
    >
      <template v-slot:[`item.workerName`]="{ item }">
        {{ workerName(item) }}
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <a class="btn" @click="addSubscriber(item)">Select </a>
      </template>

    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "AddSubscriberWorker",
  props: {
    subscribers: {
      type: Array,
      default: [],
    },
    workers: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      search: "",
      tableHeaders: [
        { text: 'Name', value: 'workerName'},
        { text: "Email", value: "email"},
        { text: "Company", value: "company"},
        { text: "", value: "action"}
      ],
    };
  },
  computed: {
    filteredWorkers(){
        return this.workers.filter(a => !this.subscribers.some(s => s.emailAddress === a.email));
    },
    searchResults() {
      if(!this.search) return this.filteredWorkers;

      return this.filteredWorkers.filter((a) => {
        return (
            this.workerName(a).toLowerCase().includes(this.search.toLowerCase()) ||
            a.email.toLowerCase().includes(this.search.toLowerCase()) ||
            a.company?.toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },
  },
  methods: {
    workerName(input){
      return `${input.firstName} ${input.lastName}`;
    },
    addSubscriber(item){
        const payload = {
            ...item,
            type: "worker"
        };
        this.$emit("addSubscriber", payload);
    }
  },
};
</script>

<style lang="scss" scoped>
</style>